import React, { Component } from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import { resolveId } from '@wix/communities-blog-client-common';

import Pagination from '../../../common/components/pagination';
import PopoverRoot from '../../../common/components/popovers/popover-root';
import withCardBorderWidth, {
  type WithCardBorderWidth,
} from '../../../common/hoc/with-card-border-width';
import PostSearchListItem from '../post-search-list-item';
import styles from './search-results-list.scss';

const ITEMS_PER_PAGE = 20;

type ItemProps = React.ComponentProps<typeof PostSearchListItem>;

type OwnProps = {
  posts: ItemProps['post'][];
  query?: string;
  onPostLikeClick: ItemProps['onLikeClick'];
  layoutType?: ItemProps['layoutType'];
};

type Props = OwnProps & WithCardBorderWidth;

type State = {
  page: number;
  from: number;
  to: number;
};

class SearchResultsDesktopList extends Component<Props, State> {
  state: State = {
    page: 1,
    from: 0,
    to: ITEMS_PER_PAGE,
  };

  handlePageChange = ({ page, from, to }: State) => this.setState({ page, from, to });

  renderItem(
    post: ItemProps['post'],
    query: string | undefined,
    onPostLikeClick: ItemProps['onLikeClick'],
  ) {
    return (
      <PostSearchListItem
        key={resolveId(post)}
        post={post}
        query={query}
        onLikeClick={onPostLikeClick}
        layoutType={this.props.layoutType}
      />
    );
  }

  render() {
    const { posts, query, onPostLikeClick, borderWidth } = this.props;
    const { page, from, to } = this.state;
    const style = {
      borderWidth,
      marginTop: -borderWidth,
    };
    return (
      <div className={classNames(styles.container, 'search-results-list')}>
        <div className={classNames(styles.wrapper, 'blog-card-border-color')} style={style}>
          {posts.slice(from, to).map((post) => this.renderItem(post, query, onPostLikeClick))}
          <Pagination
            className={classNames(styles.pagination, 'blog-card-background-color')}
            page={page}
            entityCount={posts.length}
            pageSize={ITEMS_PER_PAGE}
            onChange={this.handlePageChange}
          />
          <PopoverRoot />
        </div>
      </div>
    );
  }
}

export default flowRight(withCardBorderWidth)(SearchResultsDesktopList);
